/* ── Base ── */
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  font-family: var(--font-family);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-tight);
  border: 2px solid transparent;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: background-color var(--transition-fast),
              border-color var(--transition-fast),
              color var(--transition-fast),
              box-shadow var(--transition-fast);
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
}

.button:focus-visible {
  outline: 2px solid var(--color-border-focus);
  outline-offset: 2px;
}

.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Sizes ── */
.sm {
  padding: 0.375rem 0.75rem;
  font-size: var(--font-size-sm);
  min-height: 36px;
}

.md {
  padding: 0.625rem 1.25rem;
  font-size: var(--font-size-base);
  min-height: 44px;
}

.lg {
  padding: 0.75rem 1.5rem;
  font-size: var(--font-size-lg);
  min-height: 44px;
}

/* ── Variants ── */
.primary {
  background-color: var(--color-primary);
  color: var(--color-text-inverse);
}

.primary:hover:not(:disabled) {
  background-color: var(--color-primary-dark);
}

.secondary {
  background-color: transparent;
  border-color: var(--color-primary);
  color: var(--color-primary);
}

.secondary:hover:not(:disabled) {
  background-color: var(--color-primary);
  color: var(--color-text-inverse);
}

.danger {
  background-color: var(--color-error);
  color: var(--color-text-inverse);
}

.danger:hover:not(:disabled) {
  background-color: #b71c1c;
  /* Darkened error — no token exists for error-dark; this is the only fallback.
     TODO: Add --color-error-dark to tokens.css if needed. */
}

.ghost {
  background-color: transparent;
  color: var(--color-text);
}

.ghost:hover:not(:disabled) {
  background-color: var(--color-bg-secondary);
}

/* ── Full width ── */
.fullWidth {
  width: 100%;
}

/* ── Loading ── */
.loading {
  position: relative;
  pointer-events: none;
}

.labelLoading {
  opacity: 0.7;
}
